<template>
    <div id="contenedor-ejecucion-main">
      <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'EjecucionMain',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
